/**
 * Persist initial setup result to storage (organization and user from API response).
 * Single responsibility: write organization id/name and merged user to localStorage.
 */

const USER_STORAGE_KEY = 'user';
const ORGANIZATION_ID_KEY = 'organizationId';
const ORGANIZATION_NAME_KEY = 'organizationName';
const USER_EMAIL_KEY = 'userEmail';

/**
 * Builds user object to persist: merge stored user with API user and set organization + needsInitialSetup.
 * @param {Object} storedUser - current user from storage (or {})
 * @param {Object} user - user from API
 * @param {string} organizationId
 * @returns {Object}
 */
function mergeUserForPersistence(storedUser, user, organizationId) {
  return {
    ...(storedUser || {}),
    ...user,
    organization: organizationId,
    needsInitialSetup: false,
  };
}

/**
 * Persist organization and user from initial setup response.
 * @param {Object} response - initialSetup API response (response.data.organization, response.data.user)
 */
export function persistInitialSetupResult(response) {
  const { organization, user } = response.data ?? {};
  if (!organization || !user) return;

  localStorage.setItem(ORGANIZATION_ID_KEY, organization.id);
  localStorage.setItem(ORGANIZATION_NAME_KEY, organization.name);

  const storedUser = JSON.parse(localStorage.getItem(USER_STORAGE_KEY) || 'null');
  const mergedUser = mergeUserForPersistence(storedUser, user, organization.id);
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(mergedUser));

  if (user?.email) {
    localStorage.setItem(USER_EMAIL_KEY, user.email);
  }
}
